import React from "react";
import { motion } from "framer-motion";

/**
 * Founder Story Component - Personal journey from MARS to BibeCheck
 */
const FounderStory = ({ delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      className="max-w-5xl mx-auto mb-16 px-4">
      <div className="bg-white rounded-3xl shadow-xl p-8 sm:p-12 border border-gray-200">
        {/* Story Header */}
        <div className="mb-8">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
            Called to Build: From Church Access to Bible Access
          </h3>
        </div>

        {/* The Journey */}
        <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
          <p>
            In 2020, when churches in Singapore closed during the pandemic,
            Catholics lost access to Mass. I wanted to help.
          </p>

          <p>
            I approached our priest and he connected me with the Catholic
            Archdiocese of Singapore. Together, we created the{" "}
            <strong>Mass Attendance and Registration System</strong> — a simple
            booking system that brought people back to worship safely, fairly,
            and orderly.
          </p>

          <p>
            What began as a small tool grew in ways I never expected. By God's
            grace, it <strong>restored access</strong> to 32 churches across
            Singapore, serving 250,000+ faithful — including for the Singapore's
            200th Catholic anniversary and Pope Francis' historic visit in 2024.
          </p>

          <p className="font-semibold text-gray-900 text-lg">
            That experience taught me something beautiful:
          </p>

          <blockquote className="border-l-4 border-gray-300 pl-6 italic text-gray-600 text-lg">
            Technology, when built with love and care, it can remove the
            barriers that separate people from what their hearts are seeking.
          </blockquote>

          <p>
            That same calling is what led me to build <strong>BibeCheck</strong>
            .
          </p>

          <p>
            I see so many people — friends, family, even strangers online — who
            are genuinely curious about Scripture but feel they can't access it.{" "}
            <em>"Where do I even start?"</em> they ask.{" "}
            <em>"I don't understand the context."</em> The Bible feels out of
            reach.
          </p>

          <p className="font-semibold text-gray-900">
            BibeCheck removes those barriers.
          </p>

          <p>
            Ask any question that's on your heart. Discover how verses connect.
            Explore at your own pace. No judgment. No prerequisites. Just you
            and Scripture — accessible, finally.
          </p>

          <p className="text-gray-600">
            I'm building this with my wife and 15-month-old son cheering me on
            from Singapore. If this can help even one person access God's Word
            who never thought they could, that's everything. That hope keeps me
            building.
          </p>
        </div>

        {/* Signature */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="font-bold text-gray-900 text-lg">— Jeyner Gil Caga</p>
          <p className="text-base text-gray-500 italic mt-1">BibeCheck Builder</p>
        </div>
      </div>
    </motion.div>
  );
};

export default FounderStory;
